import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'SAVE',
}

const REQUIRED = {
  EMPRESA: 'A empresa deve ser selecionada',
  DESTINO: 'O destino deve ser informado',
}

const INITIAL = {
  id: undefined,
  tp_id: undefined,
  company_id: undefined,
  oc_code: null,
  lacre: null,
  destino: '',
  placa: null,
  _data_expedicao: null,
  status: undefined,
}

export default function useOcPrevistaModal() {
  const [state, setState] = useState({
    item: { ...INITIAL },
    loadingMessage: LOAD_MESSAGE.NONE,
    errorMessage: null,
  })

  const localDispatch = useMemo(() => {
    return {
      start(data, selectedTp) {
        if (data) {
          setState({
            item: {
              ...data,
              _data_expedicao: data.data_expedicao ? new Date(data.data_expedicao) : null,
            },
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: null,
          })
        } else {
          setState({
            item: { ...INITIAL, tp_id: selectedTp },
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: null,
          })
        }
      },
      onChange(field, value) {
        setState(prev => ({ ...prev, item: { ...prev.item, [field]: value } }))
      },
      onBtnSalvarClicked(selectedTp) {
        const it = state.item
        if (!it.company_id) setState(prev => ({ ...prev, errorMessage: REQUIRED.EMPRESA }))
        else if (!it.destino || String(it.destino).trim() === '')
          setState(prev => ({ ...prev, errorMessage: REQUIRED.DESTINO }))
        else if (!selectedTp || selectedTp === 0)
          setState(prev => ({ ...prev, errorMessage: 'Selecione o Operador Logístico' }))
        else setState(prev => ({ ...prev, errorMessage: null, loadingMessage: LOAD_MESSAGE.SAVE }))
      },
      clearError() {
        setState(prev => ({ ...prev, errorMessage: null, loadingMessage: LOAD_MESSAGE.NONE }))
      },
      async save(selectedTp) {
        try {
          const it = state.item
          const payload = {
            tp_id: it.tp_id || selectedTp,
            company_id: it.company_id,
            oc_code: it.oc_code || null,
            lacre: it.lacre || null,
            destino: it.destino,
            placa: it.placa || null,
            data_expedicao: it._data_expedicao || null,
          }

          const saved = it.id
            ? await EstoqueHttp.updateOcPrevista(it.id, payload)
            : await EstoqueHttp.saveOcPrevista(payload)

          setState(prev => ({ ...prev, errorMessage: null, loadingMessage: LOAD_MESSAGE.NONE }))
          return saved
        } catch (err) {
          setState(prev => ({ ...prev, loadingMessage: LOAD_MESSAGE.NONE }))
          throw err
        }
      },
    }
  }, [state.item])

  return { state, localDispatch }
}
